/*
 * RequestAccessPage Messages
 *
 * This contains all the text for the RequestAccessPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'requestAccess';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Request Bronte Workspace Access',
  },
  workspace: {
    id: `${scope}.workspace`,
    defaultMessage: 'Which Workspace do you want to access?',
  },
  manager: {
    id: `${scope}.manager`,
    defaultMessage: 'Approving Manager',
  },
  reason: {
    id: `${scope}.reason`,
    defaultMessage: 'Business Reason',
  },
  workspaceEmptyFeedback: {
    id: `${scope}.workspace.feedback.empty`,
    defaultMessage: 'Workspace is required.',
  },
  managerEmptyFeedback: {
    id: `${scope}.managerEmptyFeedback.feedback.empty`,
    defaultMessage: 'Approving Manager is required.',
  },
  reasonEmptyFeedback: {
    id: `${scope}.reasonEmptyFeedback.feedback.empty`,
    defaultMessage: 'Reason is required.',
  },
  submit: {
    id: `${scope}.submit`,
    defaultMessage: 'Submit',
  },
  successfullySubmitted: {
    id: `${scope}.successfullySubmitted`,
    defaultMessage: 'Request submitted successfully.',
  },
  submitError: {
    id: `${scope}.submitError`,
    defaultMessage: 'Error submitting request. Please try again.',
  },
});
